/* tslint:disable */
/* eslint-disable */
/**
 * rb-c3po-warehouse
 * API für die Verwaltung von Warenausgangsaufträgen, Artikeln, Chargen und Seriennummern
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddItemToOutboundOrderRequest
 */
export interface AddItemToOutboundOrderRequest {
    /**
     * ID des Artikels
     * @type {string}
     * @memberof AddItemToOutboundOrderRequest
     */
    articleId: string;
    /**
     * Seriennummer des Artikels
     * @type {string}
     * @memberof AddItemToOutboundOrderRequest
     */
    serialNumber?: string;
    /**
     * Charge des Artikels
     * @type {string}
     * @memberof AddItemToOutboundOrderRequest
     */
    batch?: string;
    /**
     * Mindesthaltbarkeitsdatum (YYYY-MM-DD)
     * @type {Date}
     * @memberof AddItemToOutboundOrderRequest
     */
    bestBeforeDate?: Date;
    /**
     * Herstellungsdatum (YYYY-MM-DD)
     * @type {Date}
     * @memberof AddItemToOutboundOrderRequest
     */
    productionDate?: Date;
}

/**
 * Check if a given object implements the AddItemToOutboundOrderRequest interface.
 */
export function instanceOfAddItemToOutboundOrderRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "articleId" in value;

    return isInstance;
}

export function AddItemToOutboundOrderRequestFromJSON(json: any): AddItemToOutboundOrderRequest {
    return AddItemToOutboundOrderRequestFromJSONTyped(json, false);
}

export function AddItemToOutboundOrderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddItemToOutboundOrderRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'articleId': json['articleId'],
        'serialNumber': !exists(json, 'serialNumber') ? undefined : json['serialNumber'],
        'batch': !exists(json, 'batch') ? undefined : json['batch'],
        'bestBeforeDate': !exists(json, 'bestBeforeDate') ? undefined : (new Date(json['bestBeforeDate'])),
        'productionDate': !exists(json, 'productionDate') ? undefined : (new Date(json['productionDate'])),
    };
}

export function AddItemToOutboundOrderRequestToJSON(value?: AddItemToOutboundOrderRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'articleId': value.articleId,
        'serialNumber': value.serialNumber,
        'batch': value.batch,
        'bestBeforeDate': value.bestBeforeDate === undefined ? undefined : (value.bestBeforeDate.toISOString().substr(0,10)),
        'productionDate': value.productionDate === undefined ? undefined : (value.productionDate.toISOString().substr(0,10)),
    };
}

